
import "es6-promise";

import axios, { AxiosResponse } from "axios";
import Vue, { ComponentOptions } from "vue";
import CalloutBox from "./CalloutBox.vue";
import NullarborLaunch from "./FrontPageCards/NullarborLaunch.vue";
import VariantCallsLaunch from "./FrontPageCards/VariantCallsLaunch.vue";
import RnaSeqLaunch from "./FrontPageCards/RnaSeqLaunch.vue";
import LatestNews from "./FrontPageCards/LatestNews.vue";
import SplashTexts from "./FrontPageCards/SplashTexts.vue";

interface FrontPage extends Vue { }

export default Vue.extend({
  components: {
    "callout-box": CalloutBox,
    "splash-texts": SplashTexts,
    "latest-news": LatestNews,
    "rna-seq-launch": RnaSeqLaunch,
    "nullarbor-launch": NullarborLaunch,
    "variant-calls-launch": VariantCallsLaunch,
  },
  props: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
});
